<template>
  <div>
    <div v-if="!disabled" class="jsoneditor-vue" ref="jsoneditor"></div>
    <div v-else>
      <el-input
        type="textarea"
        :value="value"
        :placeholder="placeholder"
        :disabled="true"
        :rows="4"
      >
      </el-input>
    </div>
  </div>
</template>

<style lang="less" scoped>
/deep/ div.jsoneditor-menu {
  color: #333 !important;
  background-color: #fff !important;
  border-bottom: 1px solid #d1d1d1 !important;
}
/deep/ div.jsoneditor-menu > button,
div.jsoneditor-menu > div.jsoneditor-modes > button {
  color: #333 !important;
  background-color: #aaaaaa !important;
}
/deep/ div.jsoneditor-menu > div.jsoneditor-modes > button {
  color: #333 !important;
}
/deep/ .jv-container .jv-code {
  overflow: hidden;
  padding: 10px 20px;
}
/deep/ .ace_line_group {
  text-align: left;
}
/deep/ .json-editor-container {
  display: flex;
  width: 100%;
}
/deep/ .json-editor-container .tree-mode {
  width: 50%;
}
/deep/ .json-editor-container .code-mode {
  flex-grow: 1;
}
/deep/ div.jsoneditor-tree {
  min-height: 250px;
}
/deep/ .jsoneditor-outer {
  min-height: 250px;
}
/deep/ .jsoneditor-vue {
  min-height: 250px;
}
/deep/ .ace-jsoneditor {
  min-height: 250px;
}
</style>

<script>
import "vue-json-editor/assets/jsoneditor.css";
import JsonEditor from "vue-json-editor/assets/jsoneditor";

export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String | Object | Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    mode: {
      type: String,
      default: "code",
    },
    modes: {
      type: Array,
      default: function () {
        return ["code"];
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      async handler(val) {
        if (!this.internalChange) {
          await this.refresh();
          this.expandAll();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      editor: null,
      internalChange: false,
      expandedModes: ["tree"],
    };
  },
  computed: {
    currentValue() {
      let json = {};
      try {
        json = JSON.parse(this.value);
      } catch (error) { }
      return json;
    },
  },
  mounted() {
    this.initEditor();
  },
  methods: {
    initEditor() {
      if (this.$refs.jsoneditor) {
        let self = this;
        let options = {
          mode: this.mode,
          modes: this.modes, // allowed modes
          search: false,
          history: true,
          onChange() {
            try {
              let json = self.editor.get();
              self.json = json;
              if (typeof this.value === "object") {
                self.$emit("change", json);
              } else {
                self.$emit("change", JSON.stringify(json));
              }
              self.internalChange = true;
              self.$nextTick(function () {
                self.internalChange = false;
              });
            } catch (e) {
              self.$emit("error", e);
            }
          },
          onModeChange() {
            self.expandAll();
          },
        };
        let json = {};
        if (typeof this.value === "object") {
          Object.assign(json, this.value);
        } else {
          try {
            json = JSON.parse(this.value);
          } catch (error) { }
        }
        this.editor = new JsonEditor(this.$refs.jsoneditor, options, json);
      }
    },
    expandAll() {
      if (this.editor && this.expandedModes.includes(this.editor.getMode())) {
        this.editor.expandAll();
      }
    },
    async refresh() {
      if (this.editor) {
        let json = {};
        if (typeof this.value === "object") {
          Object.assign(json, this.value);
        } else {
          try {
            json = JSON.parse(this.value);
          } catch (error) { }
        }
        this.editor.set(json);
      }
    },
  },
};
</script>
